import ConfirmationModal from '../components/ConfirmationModal';
import * as Constants from '../constants/redux';
import { getEmojiItemByChar } from '../utils/emoji';

const UIActions = {
  closeRightPanel: (reset = false) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_RIGHT_PANEL_CLOSE,
        reset,
      });
    };
  },

  closeModal: (reset = false) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_MODAL_CLOSE,
        reset,
      });
    };
  },

  confirmModal: (props) => {
    return UIActions.openModal(ConfirmationModal, props);
  },

  openModal: (View, props = {}) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_MODAL_OPEN,
        View,
        props,
      });
    };
  },

  openRightPanel: (View, props = {}) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_RIGHT_PANEL_OPEN,
        View,
        props,
      });
    };
  },

  clearToasts: () => {
    return (dispatch) => {
      return dispatch({ type: Constants.UI_TOAST_CLEAR });
    };
  },

  pushToast: (render, duration = 5000) => {
    return (dispatch) => {
      const id = Math.random().toString(36).slice(-4);
      if (duration > 0) {
        setTimeout(() => {
          dispatch(UIActions.removeToast(id));
        }, duration);
      }
      dispatch({
        type: Constants.UI_TOAST_PUSH,
        id,
        render,
      });
      return Promise.resolve(id);
    };
  },

  removeToast: (id) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_TOAST_REMOVE,
        id,
      });
    };
  },

  setStickyTOCPreferred: (value) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_STICKY_TOC_PREFERRED_SET,
        value,
      });
    };
  },

  toggleSidebar: (forceValue) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_SIDEBAR_TOGGLE,
        forceValue,
      });
    };
  },

  toggleSidebarSection: (section) => ({
    type: Constants.UI_SIDEBAR_TOGGLE_SECTION,
    section,
  }),

  toggleOrganizationSummaryCollapsed: (collapsed) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_ORGANIZATION_SUMMARY_COLLAPSED,
        collapsed,
      });
    };
  },

  toggleUserProfileCollapsed: (collapsed) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_USER_PROFILE_COLLAPSED,
        collapsed,
      });
    };
  },

  toggleTopicDescription: (id) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_TOPIC_DESCRIPTION_TOGGLE,
        id,
      });
    };
  },

  changeTopicPostsOrderBy: (topicId, orderBy) => (dispatch) =>
    dispatch({
      type: Constants.UI_TOPIC_POSTS_ORDER_BY_CHANGED,
      orderBy,
      topicId,
    }),

  hideMentionIntegrationPrompt: (platform) => (dispatch) =>
    dispatch({
      type: Constants.UI_MENTION_INTEGRATION_PROMPT_HIDE,
      platform,
    }),

  changeHelpMenuOpen: (open) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_HELP_MENU_OPEN_CHANGED,
        open,
      });
    };
  },

  changePostTopicSelectOpen: (open) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_POST_TOPIC_SELECT_OPEN_CHANGED,
        open,
      });
    };
  },

  changeHelpMenuVisible: (visible) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_HELP_MENU_VISIBLE_CHANGED,
        visible,
      });
    };
  },

  addToRecentlyUsedEmojis: (char) => {
    return (dispatch) => {
      const emoji = getEmojiItemByChar(char);
      if (emoji) {
        dispatch({
          type: Constants.UI_RECENTLY_USED_EMOJIS_ADDED,
          name: emoji.name,
        });
      }
    };
  },

  addToRecentlyViewedPostIds: (postIds) => {
    return (dispatch) => {
      dispatch({ type: Constants.UI_RECENTLY_VIEWED_POSTS_ADDED, postIds });
    };
  },

  removeFromRecentlyViewedPostIds: (postId) => {
    return (dispatch) => {
      dispatch({ type: Constants.UI_RECENTLY_VIEWED_POSTS_REMOVED, postId });
    };
  },

  changeEmojiSkinToneModifier: (value) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_EMOJI_SKIN_TONE_CHANGED,
        value,
      });
    };
  },

  changeCodeBlockSyntax: (value) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_CODE_BLOCK_SYNTAX_CHANGED,
        value,
      });
    };
  },

  hideIntegrationBanner: () => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_INTEGRATION_BANNER_HIDE,
      });
    };
  },

  dismissSearchConnectionPrompt: (platform) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_DISMISS_SEARCH_CONNECTION_PROMPT,
        platform,
      });
    };
  },

  addUsedTemplate: (templateId) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_ADD_USED_TEMPLATE,
        templateId,
      });
    };
  },

  addMentionedUser: (userId) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_ADD_MENTIONED_USER,
        userId,
      });
    };
  },

  setExternalTopbarLoginRedirectPath: (redirectPath) => {
    return (dispatch) => {
      return dispatch({
        type: Constants.UI_SET_EXTERNAL_TOPBAR_LOGIN_REDIRECT_PATH,
        redirectPath,
      });
    };
  },

  setExternalPostsOrder: (orderBy) => (dispatch) =>
    dispatch({
      type: Constants.UI_SET_EXTERNAL_POSTS_ORDER,
      orderBy,
    }),

  setDraftsOrder: (orderBy) => (dispatch) =>
    dispatch({
      type: Constants.UI_SET_DRAFTS_ORDER,
      orderBy,
    }),
};

export default UIActions;
